import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
// eslint-disable-next-line react/display-name
export const Title = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { children, className, ...rest } = props;
    return /*#__PURE__*/ _jsx("h5", {
        ref: ref,
        className: className,
        ...rest,
        children: props.children
    });
});
Title.displayName = 'Title';
